import {Banner, Switch} from '@wandb/components';
import React from 'react';

import {useBaselineSettings} from './useBaselineSettings';

const BASELINE_SWITCH_DESCRIPTION = `
  You can set metric directionality for each column to enhance deltas with
  heat-map coloring.
`;

function NoBaselineBanner() {
  return (
    <Banner isDismissible={false}>
      <p>
        <b>This workspace doesn't have a baseline yet.</b> You can mark a run as
        baseline by clicking on its menu in the runs list.
      </p>
    </Banner>
  );
}

export function BaselineSettings() {
  const {hasBaselineRun, setShowMetricDelta, showMetricDeltas} =
    useBaselineSettings();

  return (
    <div className="flex flex-col gap-16 py-8">
      {!hasBaselineRun ? <NoBaselineBanner /> : null}
      <Switch
        description={BASELINE_SWITCH_DESCRIPTION}
        isSelected={showMetricDeltas}
        onChange={() => setShowMetricDelta(!showMetricDeltas)}>
        Show value deltas in the runs table
      </Switch>
    </div>
  );
}
